import { useCallback, useEffect, useState } from 'react'
import { Card, Form } from 'react-bootstrap';
import { Grid, Box, Divider } from '@mui/material';
import $ from 'jquery'
import _ from 'lodash'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import { UploadImage } from 'features/warehouses/products/style'

/** API */
import { routeName } from 'routes/routes-name'
import ProductTypesApi from 'api/setting/default-products/product-type.api'

/** UTILS || SLICE */
import { imgs, icons } from 'constants/images'

/** COMPONENT */
import ButtonCustom from 'component/Button/ButtonCustom'
import InputTextField from 'component/Input/InputTextField'
import { notiSuccess } from 'component/notifications/notifications';
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import InputCheckbox from 'component/Input/InputCheckbox'
import InputTextarea from 'component/Input/InputTextarea'
import ProductUnitsApi from 'api/setting/default-products/product-unit.api'
import ProductInstructionsApi from 'api/setting/default-products/product-instruction.api'
import ProductPreservesApi from 'api/setting/default-products/product-preserve.api'
import { useParams } from 'react-router'
import ProductsApi from 'api/warehouses/product.api'
import { fileUrl } from 'api/api'
import { colors } from 'constants/theme'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import { numberOnly } from 'utils/app.utils';
import { FormProductBarcode } from '../medicines/form-medicines';

type RawFileType = {
  fileId?: number | null
  base64?: string | null
  fileName?: string | null
  fileExtension?: string | null
  fileSize?: string | null
}

const initStateErrorMessage = {
  PRODUCT_CODE: ``,
  PRODUCT_NAME: ``,
  PRODUCT_NAME_EN: ``,
  PRODUCT_TYPE_ID: ``,
  PRODUCT_FORMAT_ID: ``,
  PRODUCT_UNIT_ID: ``,
  SALE_PRICE: ``,
  COST_PRICE: ``,
  MIN_STOCK: ``,
  IS_DUPLICATE_PRODUCT_NAME: ``,
  PRODUCT_NAME_STRING_BASE: ``,
  PRODUCT_NAME_MAXIMUM_LENGTH: ``,
  PRODUCT_NAME_STRING_EMPTY: ``,
  PRODUCT_NAME_ANY_REQUIRED: ``,
  IS_DUPLICATE_PRODUCT_NAME_EN: ``,
  PRODUCT_NAME_EN_STRING_BASE: ``,
  PRODUCT_NAME_EN_MAXIMUM_LENGTH: ``,
  PRODUCT_NAME_EN_STRING_EMPTY: ``,
  PRODUCT_NAME_EN_ANY_REQUIRED: ``,
  IS_DUPLICATE_PRODUCT_CODE: ``,
  IS_DUPLICATE_PRODUCT_BARCODE: ``,
  PRODUCT_CODE_STRING_BASE: ``,
  PRODUCT_CODE_MAXIMUM_LENGTH: ``,
  PRODUCT_CODE_STRING_EMPTY: ``,
  PRODUCT_CODE_ANY_REQUIRED: ``,
}

export default function FormProducts() {
  const { t } = useTranslation()
  const { id }: any = useParams()

  const [productTypes, setProductTypes]: any = useState([])
  const [productUnits, setProductUnits] = useState([])
  const [productInstructions, setProductInstructions] = useState([])
  const [productPreserves, setProductPreserves] = useState([])
  const [productId, setProductId] = useState(Number)
  const [productCode, setProductCode] = useState('')
  const [productName, setProductName] = useState('')
  const [productNameEn, setProductNameEn] = useState('')
  const [productTypeId, setProductTypeId] = useState<number | null>(null)
  const [productFormatId, setProductFormatId] = useState<number | null>(null)
  const [productUnitId, setProductUnitId] = useState<number | null>(null)
  const [productInstructionId, setProductInstructionId] = useState<number | null>(null)
  const [productPreserveId, setProductPreserveId] = useState<number | null>(null)
  const [productUseId, setProductUseId] = useState<number | null>(null)
  const [strength, setStrength] = useState('')
  const [salePrice, setSalePrice] = useState<any>('')
  const [costPrice, setCostPrice] = useState<any>('')
  const [minStock, setMinStock] = useState<any>('')
  const [explanation, setExplanation] = useState('')
  const [showOnReceipt, setShowOnReceipt] = useState(`SHOW`)
  const [statusProduct, setStatusProduct] = useState(`ACTIVE`)
  const [amounDayBeforeExpired, setAmounDayBeforeExpired] = useState<any>('');

  const [numberBarcode, setNumberBarcode] = useState<string>('')

  const [files, setFiles] = useState<RawFileType[]>([])
  const [image, setImage] = useState({
    fileId: null,
    base64: '',
    fileExtension: '',
    fileSize: ''
  })

  const [defaultProductType, setDefaultProductType] = useState({ label: ``, value: `` })
  const [defaultProductUnit, setDefaultProductUnit] = useState({ label: ``, value: `` })
  const [defaultProductInstruction, setDefaultProductInstruction] = useState({ label: ``, value: `` })
  const [defaultProductPreserve, setDefaultProductPreserve] = useState({ label: ``, value: `` })

  const [imgData, setImgData]: any = useState()
  const [filesData, setFilesData]: any = useState([])

  const [errorMessage, setErrorMessage]: any = useState(initStateErrorMessage)
  const [statusAdd, setStatusAdd] = useState<boolean>(false)

  const loadData = useCallback(() => {
    loadProductTypes()
    loadProductUnits()
    loadProductInstructions()
    loadProductPreserves()
  }, [])

  useEffect(() => {
    loadData()
    if (id !== undefined) loadProductById()
  }, [loadData])

  const loadProductTypes = async (search = null) => {
    let condition: any = { group: 'PRODUCT', pageLimit: 10, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductTypesApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productTypeName, value: value.productTypeId }
      })
      setProductTypes(newData)
    }
  }

  const loadProductUnits = async (search = null) => {
    let condition: any = { group: 'PRODUCT', pageLimit: 10, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductUnitsApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productUnitName, value: value.productUnitId }
      })
      setProductUnits(newData)
    }
  }

  const loadProductInstructions = async (search = null) => {
    let condition: any = { group: 'PRODUCT', pageLimit: 10, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductInstructionsApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productInstructionName, value: value.productInstructionId }
      })
      setProductInstructions(newData)
    }
  }

  const loadProductPreserves = async (search = null) => {
    let condition: any = { group: 'PRODUCT', pageLimit: 10, status: 'ACTIVE' }
    if (search) condition = { ...condition, search: search }
    const res = await ProductPreservesApi.findAll(condition)
    if (res.status === 200) {
      const newData = res.data.map((value: any) => {
        return { label: value.productPreserveName, value: value.productPreserveId }
      })
      setProductPreserves(newData)
    }
  }

  const loadProductById = async () => {
    const { status, data }: any = await ProductsApi.findById(id)
    if (status === 200) {
      setProductId(data.productId)
      setProductCode(data.productCode)
      setProductName(data.productName)
      setProductNameEn(data.productNameEn)
      setProductTypeId(data.productTypeId)
      setProductFormatId(data.productFormatId)
      setProductUnitId(data.productUnitId)
      setProductInstructionId(data.productInstructionId)
      setProductPreserveId(data.productPreserveId)
      setProductUseId(data.productUseId)
      setStrength(data.strength)
      setSalePrice(data.salePrice)
      setCostPrice(data.costPrice)
      setMinStock(data.minStock)
      setExplanation(data.explanation)
      setShowOnReceipt(data.showOnReceipt)
      setStatusProduct(data.status)
      setAmounDayBeforeExpired(data.amounDayBeforeExpired)
      setNumberBarcode(data?.numberBarcode || '')

      if (data.image) {
        setImgData(`${fileUrl}/${data.image.filePath}/${data.image.fileName}`)
        setImage({ fileId: data.image.fileId, base64: '', fileExtension: '', fileSize: '' })
      }

      if (data.files) {
        const fileArray = []
        const rawFiles = []
        for (const index in data.files) {
          const file = data.files[index]
          rawFiles.push({
            fileId: file.fileId,
            base64: '',
            fileName: file.fileName,
            fileExtension: '',
            fileSize: '',
          })
          fileArray.push({ fileName: `${file?.fileName || '-'}`, filePathFull: `${fileUrl}/${file.filePath}/${file.fileName}` })
        }
        setFiles(rawFiles)
        setFilesData(fileArray)
      }

      if (data.productType) setDefaultProductType({ label: data.productType.productTypeName, value: data.productType.productTypeId })
      if (data.productUnit) setDefaultProductUnit({ label: data.productUnit.productUnitName, value: data.productUnit.productUnitId })
      if (data.productInstruction) setDefaultProductInstruction({ label: data.productInstruction.productInstructionName, value: data.productInstruction.productInstructionId })
      if (data.productPreserve) setDefaultProductPreserve({ label: data.productPreserve.productPreserveName, value: data.productPreserve.productPreserveId })
    }
  }

  const submit = () => {
    if (!productName || !productCode || !productTypeId || !productUnitId || costPrice.toString() === '' || salePrice.toString() === '' || minStock.toString() === '' || numberBarcode.length < 13 && numberBarcode.length > 0) {
      return setErrorMessage({
        PRODUCT_NAME: !productName ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_NAME`) : '',
        PRODUCT_CODE: !productCode ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_CODE`) : '',
        PRODUCT_TYPE_ID: !productTypeId ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_TYPE`) : '',
        PRODUCT_UNIT_ID: !productUnitId ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_UNIT`) : '',
        COST_PRICE: costPrice.toString() === '' ? t(`PRODUCT.MESSAGE.NONE_COST_PRICE`) : '',
        SALE_PRICE: salePrice.toString() === '' ? t(`PRODUCT.MESSAGE.NONE_SALE_PRICE`) : '',
        MIN_STOCK: minStock.toString() === '' ? t(`PRODUCT.MESSAGE.NONE_MIN_STOCK`) : '',
        COMPLETE_BARCODE: (numberBarcode.length < 13 && numberBarcode.length > 0) ? t(`PRODUCT.MESSAGE.COMPLETE_BARCODE`) : ''
      })
    }

    const objCreate = {
      group: 'PRODUCT',
      productCode: productCode,
      productName: productName,
      productNameEn: productNameEn,
      productTypeId: productTypeId,
      productFormatId: productFormatId,
      productUnitId: productUnitId,
      productInstructionId: productInstructionId,
      productPreserveId: productPreserveId,
      productUseId: productUseId,
      strength: strength,
      salePrice: Number(salePrice),
      costPrice: Number(costPrice),
      minStock: Number(minStock),
      explanation: explanation,
      showOnReceipt: showOnReceipt,
      files: files,
      image: image,
      amounDayBeforeExpired: amounDayBeforeExpired,
      numberBarcode: numberBarcode
    }
    if (objCreate.productCode !== undefined && objCreate.productCode !== '' && (objCreate.numberBarcode.length === 13 || objCreate.numberBarcode.length === 0)) {
      setStatusAdd(true)
      ProductsApi.create(objCreate)
        .then((res: any) => {
          if (res.status !== undefined && res.status === 201) {
            setStatusAdd(true)
            notiSuccess(t(`PRODUCT.MESSAGE.ADD_SUCCESS`))
            window.location.href = routeName.product
            // setTimeout(() => { window.location.href = routeName.product }, 1000)
          }
          else {
            setStatusAdd(false)
            const err = res.response.data
            setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.${err.message}`) } })
          }
        })
        .catch((e) => {
          setStatusAdd(false)
          const err = e.response.data
          if (err.message === 'IS_DUPLICATE_PRODUCT_NAME') return setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.PRODUCT_USE`) } })
          else if (err.message === 'IS_DUPLICATE_PRODUCT_BARCODE') return setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.IS_DUPLICATE_PRODUCT_BARCODE`) } })
          else return setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.PRODUCT_DUP`) } })
        })
    }
  }

  const submitUpdate = () => {
    if (!productName || !productCode || !productTypeId || !productUnitId || costPrice.toString() === '' || salePrice.toString() === '' || minStock.toString() === '' || numberBarcode.length < 13 && numberBarcode.length > 0) {
      return setErrorMessage({
        PRODUCT_NAME: !productName ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_NAME`) : '',
        PRODUCT_CODE: !numberBarcode ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_CODE`) : '',
        PRODUCT_TYPE_ID: !productTypeId ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_TYPE`) : '',
        PRODUCT_UNIT_ID: !productUnitId ? t(`PRODUCT.MESSAGE.NONE_PRODUCT_UNIT`) : '',
        COST_PRICE: costPrice.toString() === '' ? t(`PRODUCT.MESSAGE.NONE_COST_PRICE`) : '',
        SALE_PRICE: salePrice.toString() === '' ? t(`PRODUCT.MESSAGE.NONE_SALE_PRICE`) : '',
        MIN_STOCK: minStock.toString() === '' ? t(`PRODUCT.MESSAGE.NONE_MIN_STOCK`) : '',
        COMPLETE_BARCODE: numberBarcode.length < 13 && numberBarcode.length > 0 ? t(`PRODUCT.MESSAGE.COMPLETE_BARCODE`) : ''
      })
    }

    const objUpdate = {
      group: 'PRODUCT',
      productCode: productCode,
      productName: productName,
      productNameEn: productNameEn,
      productTypeId: productTypeId,
      productFormatId: productFormatId,
      productUnitId: productUnitId,
      productInstructionId: productInstructionId,
      productPreserveId: productPreserveId,
      productUseId: productUseId,
      strength: strength,
      salePrice: Number(salePrice),
      costPrice: Number(costPrice),
      minStock: Number(minStock),
      explanation: explanation,
      showOnReceipt: showOnReceipt,
      status: statusProduct,
      files: files,
      image: image,
      amounDayBeforeExpired: amounDayBeforeExpired,
      numberBarcode: numberBarcode
    }

    if (objUpdate.productCode !== undefined && objUpdate.productCode !== '' && (objUpdate.numberBarcode.length === 13 || objUpdate.numberBarcode.length === 0)) {
      setStatusAdd(true)
      ProductsApi.update(productId, objUpdate)
        .then((res: any) => {
          if (res.status !== undefined && res.status === 200) {
            setStatusAdd(true)
            notiSuccess(t(`PRODUCT.MESSAGE.EDIT_SUCCESS`))
            loadData()
            setTimeout(() => { window.location.href = routeName.product }, 1000)
          }
          else {
            setStatusAdd(false)
            const err = res.response.data
            setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.${err.message}`) } })
          }
        })
        .catch((e) => {
          setStatusAdd(false)
          const err = e.response.data
          if (err.message === 'IS_DUPLICATE_PRODUCT_NAME') return setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.PRODUCT_USE`) } })
          else if (err.message === 'IS_DUPLICATE_PRODUCT_BARCODE') return setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.IS_DUPLICATE_PRODUCT_BARCODE`) } })
          else return setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PRODUCT.MESSAGE.PRODUCT_DUP`) } })
        })
    }
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      /**
       * e.target.files all detail file
       * lastModified, lastModifiedDate
       * name, size, type
       */
      const file = e.target.files[0]

      const fileName = file.name.split('.')
      const detailImage = {
        fileId: null,
        base64: '',
        fileExtension: fileName[fileName.length - 1],
        fileSize: file.size.toString()
      }
      const reader: any = new FileReader()
      reader.addEventListener('load', () => {
        /** reader.result is base64 */
        const base64 = reader.result.split(',')
        setImgData(reader.result)
        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
      })
      reader.readAsDataURL(file)
      setImage(detailImage)
    }
  }

  const onChangeFiles = (e: any) => {
    if (e.target.files) {
      /**
       * e.target.files all detail file
       * lastModified, lastModifiedDate
       * name, size, type
       */
      const rawFiles: any = []
      const fileNames: any = []
      for (let index = 0; index < e.target.files.length; index++) {
        const file = e.target.files[index]
        fileNames.push({ fileName: file.name, filePathFull: null })
        const fileName = file.name.split('.')
        const detailFile = {
          fileId: null,
          base64: '',
          fileExtension: fileName[fileName.length - 1],
          fileName: file.name,
          fileSize: file.size.toString()
        }
        const reader: any = new FileReader()
        reader.addEventListener('load', () => {
          /** reader.result is base64 */
          const base64 = reader.result.split(',')
          detailFile.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
        })
        reader.readAsDataURL(file)
        rawFiles.push(detailFile)
      }

      setFiles([...files, ...rawFiles])
      setFilesData([...filesData, ...fileNames])
    }
  }

  const handleDeleteFile = (refId: number) => {
    setFiles(_.filter(files, (fs, indexFs: number) => indexFs !== refId))
    setFilesData(_.filter(filesData, (fd, indexFd: number) => indexFd !== refId))
  }

  const handleShowOnReceipt = () => {
    setShowOnReceipt(showOnReceipt === 'SHOW' ? 'HIDE' : 'SHOW')
    clearErrorMessage()
    setSalePrice(0)
  }

  return (
    <div className={`h-100 container-card overflow-hidden`} style={{ backgroundColor: colors.white }}>
      <div className='h-100 d-flex flex-column'>
        <HeaderLabel
          text={productId ? t('PRODUCT.HEADER.TITLE_EDIT') : t('PRODUCT.HEADER.TITLE_ADD')}
          navigator={{ previousTo: routeName.product, previousTitle: t('PRODUCT.HEADER.TITLE'), currentTitle: productId ? t('PRODUCT.HEADER.TITLE_EDIT') : t('PRODUCT.HEADER.TITLE_ADD') }}
          goBack={routeName.product}
          onSubmit={productId ? submitUpdate : submit}
          disabledSend={statusAdd}
        />

        <Card className="border shadow-sm mx-4 mb-4 overflow-hidden h-100" style={{ maxWidth: '100%' }}>
          <Card.Body className="h-100 py-0 d-xl-flex">
            <Box className="overflow-auto w-100" sx={{ overflow: { lg: 'hidden !important' }, maxHeight: { lg: 'unset !important' } }} style={{ maxHeight: '100%' }}>
              <Grid container spacing={2} className="pl-3 pl-lg-0 mt-0 h-100 flex-column flex-xl-row flex-nowrap">
                <Grid item lg={2} className="p-3 w-100 d-flex flex-column" sx={{ borderRight: { lg: `1px solid ${colors.lightGray}` }, maxHeight: '100%' }}>
                  <UploadImage
                    className={`align-content-center flex-center mx-auto mb-3`}
                    onClick={() => {
                      $('#profilePic').click()
                    }}>
                    <Box className='image-wrap'>
                      <div className="d-none">
                        <input id="profilePic" type="file" accept='image/*' onChange={onChangePicture} />
                      </div>
                      {imgData ? (
                        <img className={`image-preview `} src={imgData} alt="" />
                      ) : (
                        <div className={'upload-image text-center w-100 h-100 d-flex flex-column align-items-center justify-content-center'}>
                          <img src={imgs.defaultAddImage} alt="uploadImage" />
                          <p className={'pt-1 pt-sm-2 m-0'}>{t('REGISTER.UPLOAD_TREATMENT.UPLOAD_IMAGE')}</p>
                        </div>
                      )}
                    </Box>
                  </UploadImage>
                  {productId ? (
                    <div>
                      <Form className="m-0 p-0 d-flex align-items-center justify-content-center justify-content-xl-between w-100">
                        <Form.Label className="mr-3 mb-0">{t('INPUT.LABEL_STATUS')}</Form.Label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          onChange={() => setStatusProduct(statusProduct === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                          checked={statusProduct === 'ACTIVE' ? true : false}
                          className="ml-xl-auto"
                        />
                      </Form>
                      <Divider className="mx-0 my-3" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                    </div>
                  ) : (
                    ''
                  )}
                  <div className='overflow-auto custom-scroll'>
                    <p className='m-0' style={{ fontWeight: 500 }}>{t('PRODUCT.FORM.DOCUMENT_INFO')}</p>
                    <div className="mt-1">
                      <div className="d-none">
                        <input id="uploadFiles" multiple type="file" accept=".pdf" onChange={onChangeFiles} />
                      </div>
                      <ButtonCustom
                        variant="text"
                        textButton={t('PRODUCT.FORM.ADD_DOCUMENT')}
                        onClick={() => {
                          $('#uploadFiles').click()
                        }}
                        btnStyle={{ fontSize: 16 }}
                      />
                    </div>
                    {filesData &&
                      filesData.map((file: any, i: number) => (
                        <div key={i} className="d-flex align-items-center overflow-hidden">
                          <label
                            htmlFor={`contained-button-file-${i}`}
                            className={`d-flex align-items-center mr-3 text-ellipsis  ${file.filePathFull ? 'cursor-pointer' : ''}`}
                            onClick={() => file.filePathFull && window.open(file.filePathFull)}>
                            <img src={icons.attachmentLine} className={'mr-2'} alt="" />
                            <span className='text-ellipsis' style={{ textDecoration: file.filePathFull ? 'underline' : 'none' }}>{file.fileName}</span>
                          </label>
                          <img src={icons.trashOutlined} onClick={(e) => handleDeleteFile(i)} alt="" className="cursor-pointer ml-auto" />
                        </div>
                      ))}
                  </div>
                </Grid>
                <Grid item lg={10} className={'pl-0 pl-lg-3 py-3 w-100 h-100 overflow-hidden d-flex flex-column'}>
                  <div className='d-flex flex-column overflow-auto custom-scroll'>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={4} className="w-100">
                        <Box className='mt-2'>
                          <InputTextField
                            hookValue={true}
                            onchange={(event) => {
                              clearErrorMessage()
                              setProductName(event.target.value)
                            }}
                            label={t('PRODUCT.FORM.PRODUCT_NAME')}
                            value={productName}
                            key={`product-name`}
                            inputProps={{ maxLength: 255 }}
                            required={true}
                            helperText={errorMessage.PRODUCT_NAME || errorMessage.IS_DUPLICATE_PRODUCT_NAME || errorMessage.PRODUCT_NAME_STRING_BASE || errorMessage.PRODUCT_NAME_MAXIMUM_LENGTH || errorMessage.PRODUCT_NAME_STRING_EMPTY || errorMessage.PRODUCT_NAME_ANY_REQUIRED}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6} md={4} className="w-100">
                        <Box className='mt-2'>
                          <InputTextField
                            hookValue={true}
                            onchange={(event) => {
                              clearErrorMessage()
                              setProductNameEn(event.target.value)
                            }}
                            label={t('PRODUCT.FORM.PRODUCT_NAME_ENG')}
                            value={productNameEn}
                            key={`product-name-en`}
                            inputProps={{ maxLength: 255 }}
                            required={false}
                            helperText={errorMessage.PRODUCT_NAME_EN || errorMessage.IS_DUPLICATE_PRODUCT_NAME_EN || errorMessage.PRODUCT_NAME_EN_STRING_BASE || errorMessage.PRODUCT_NAME_EN_MAXIMUM_LENGTH || errorMessage.PRODUCT_NAME_EN_STRING_EMPTY || errorMessage.PRODUCT_NAME_EN_ANY_REQUIRED}
                          />
                        </Box>
                      </Grid>
                      <Grid item className="w-100">
                        <div className='ml-1'>
                          <InputCheckbox onChange={handleShowOnReceipt} checked={showOnReceipt === 'SHOW' ? true : false} label={t('PRODUCT.FORM.SHOW_ON_RECEIPT')} />
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} className="mt-0">
                      <Grid item className="w-100">
                        <Divider className="m-0" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                      </Grid>
                      <Grid item className="w-100">
                        <p className='m-0' style={{ fontSize: 18, fontWeight: 500 }}>{t('PRODUCT.FORM.PRODUCT_DETAIL')}</p>
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <InputTextField
                          hookValue={true}
                          onchange={(event) => {
                            clearErrorMessage()
                            setProductCode(event.target.value)
                          }}
                          label={t('PRODUCT.FORM.PRODUCT_CODE')}
                          value={productCode}
                          key={`product-code`}
                          inputProps={{ maxLength: 20 }}
                          required={true}
                          helperText={errorMessage.PRODUCT_CODE || errorMessage.IS_DUPLICATE_PRODUCT_CODE || errorMessage.PRODUCT_CODE_STRING_BASE || errorMessage.PRODUCT_CODE_MAXIMUM_LENGTH || errorMessage.PRODUCT_CODE_STRING_EMPTY || errorMessage.PRODUCT_CODE_ANY_REQUIRED}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <AutocompleteSelect
                          labelId="product-type"
                          inputLabel={t('PRODUCT.FORM.PRODUCT_TYPE')}
                          options={productTypes}
                          onchange={(e, val) => {
                            clearErrorMessage()
                            if (val) {
                              const { label, value }: any = val
                              setProductTypeId(value)
                              setDefaultProductType({ label, value })
                            } else {
                              setProductTypeId(null)
                              setDefaultProductType({ label: ``, value: `` })
                            }
                          }}
                          onOpen={(event, value) => loadProductTypes()}
                          onClose={(event, value) => loadProductTypes()}
                          noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                          onInputChange={(event: any, newValue: any) => loadProductTypes(newValue)}
                          value={defaultProductType}
                          errMessage={errorMessage.PRODUCT_TYPE_ID}
                          disableClearable
                          required
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <AutocompleteSelect
                          labelId="product-unit"
                          inputLabel={t('PRODUCT.FORM.PRODUCT_UNIT')}
                          options={productUnits}
                          onchange={(e, val) => {
                            clearErrorMessage()
                            if (val) {
                              const { label, value }: any = val
                              setProductUnitId(value)
                              setDefaultProductUnit({ label, value })
                            } else {
                              setProductUnitId(null)
                              setDefaultProductUnit({ label: ``, value: `` })
                            }
                          }}
                          onOpen={(event, value) => loadProductUnits()}
                          onClose={(event, value) => loadProductUnits()}
                          noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                          onInputChange={(event: any, newValue: any) => loadProductUnits(newValue)}
                          value={defaultProductUnit}
                          errMessage={errorMessage.PRODUCT_UNIT_ID}
                          required
                          disableClearable
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <AutocompleteSelect
                          labelId="product-instruction"
                          inputLabel={t('PRODUCT.FORM.PRODUCT_HOWTO')}
                          options={productInstructions}
                          onchange={(e, val) => {
                            setProductInstructionId(val?.value || 0)
                            setDefaultProductInstruction({ label: val?.label || ``, value: val?.value || `` })
                          }}
                          onOpen={(event, value) => loadProductInstructions()}
                          onClose={(event, value) => loadProductInstructions()}
                          noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                          onInputChange={(event: any, newValue: any) => loadProductInstructions(newValue)}
                          value={defaultProductInstruction}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <AutocompleteSelect
                          labelId="product-preserve"
                          inputLabel={t('PRODUCT.FORM.PRODUCT_PRESERVES')}
                          getOptionLabel={(option: any) => option.label}
                          options={productPreserves}
                          onchange={(e, val) => {
                            setProductPreserveId(val?.value || 0)
                            setDefaultProductPreserve({ label: val?.label || ``, value: val?.value || `` })
                          }}
                          onOpen={(event, value) => loadProductPreserves()}
                          onClose={(event, value) => loadProductPreserves()}
                          noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                          onInputChange={(event: any, newValue: any) => loadProductPreserves(newValue)}
                          value={defaultProductPreserve}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <InputTextField
                          hookValue={true}
                          onchange={(event) => {
                            clearErrorMessage()
                            setCostPrice(numberOnly(event))
                          }}
                          label={t('PRODUCT.FORM.PRODUCT_FUND')}
                          value={costPrice}
                          key={`cost-price`}
                          inputProps={{ maxLength: 12 }}
                          required={true}
                          helperText={errorMessage['COST_PRICE']}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <InputTextField
                          hookValue={true}
                          disabled={showOnReceipt === "HIDE" ? true : false}
                          onchange={(event) => {
                            clearErrorMessage()
                            setSalePrice(numberOnly(event))
                          }}
                          label={t('PRODUCT.FORM.PRODUCT_PRICE')}
                          value={salePrice}
                          key={`sale-price`}
                          inputProps={{ maxLength: 12 }}
                          required={true}
                          helperText={errorMessage['SALE_PRICE']}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <InputTextField
                          hookValue={true}
                          onchange={(event) => {
                            clearErrorMessage()
                            setMinStock(numberOnly(event))
                          }}
                          label={t('PRODUCT.FORM.MINSTOCK')}
                          value={minStock}
                          key={`min-stock`}
                          required={true}
                          inputProps={{ maxLength: 11 }}
                          helperText={errorMessage['MIN_STOCK']}
                        />
                      </Grid>
                      <Grid item xs={6} md={4} lg={3} className="w-100">
                        <InputTextField
                          hookValue={true}
                          onchange={(event) => {
                            const value = numberOnly(event)
                            setAmounDayBeforeExpired(value.length >= 2 ? value.slice(0, 2) : value)
                            clearErrorMessage()
                          }}
                          inputProps={{ maxLength: 2 }}
                          label={t('PRODUCT.FORM.EXPIRED')}
                          value={amounDayBeforeExpired}
                          key={`expired`}
                          hideControl
                        />
                      </Grid>
                      <Grid item className="w-100">
                        <InputTextarea
                          onchange={(event) => {
                            clearErrorMessage()
                            setExplanation(event.target.value)
                          }}
                          value={explanation}
                          label={t('PRODUCT.FORM.EXPLANATION')}
                          helperText=""
                        />
                      </Grid>
                      <Grid item className="w-100">
                        <FormProductBarcode
                          helperTextError={
                            errorMessage.IS_DUPLICATE_PRODUCT_BARCODE || (numberBarcode.length === 0 || numberBarcode.length === 13 ? '' : errorMessage['COMPLETE_BARCODE'])
                          }
                          valueBarcode={numberBarcode}
                          onChange={(event) => {
                            clearErrorMessage()
                            const inputValue = event.target.value;
                            const regex = /^[0-9]{0,13}$/;
                            if (regex.test(inputValue)) {
                              setNumberBarcode(inputValue);
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
